<template>
	<div style="position: relative;">
		<header id="header" class="header-nav">
			<div class="header-size header-top">
				<div class="d-flex align-items-center justify-content-between">
					<div class="logo" @click="tohome()">
						<img src="../assets/img/nav/n-4-1.png" />
					</div>
				</div>
				<div class="logo-not-logged">
					<el-dropdown @command="changeLanguage">
						<div class="language-button">
							<div class="language-icon-2">
								<img src="../assets/img/nav/n-6.png" />
							</div>
							<div v-if="language=='zh' || language==''">{{$t('nav.nav_lang_zh')}}</div>
							<div v-if="language=='en'">{{$t('nav.nav_lang_en')}}</div>
							<div v-if="language=='tw'">{{$t('nav.nav_lang_tw')}}</div>
							<div v-if="language=='ja'">{{$t('nav.nav_lang_ja')}}</div>
							<div v-if="language=='ko'">{{$t('nav.nav_lang_ko')}}</div>
							<div v-if="language=='ru'">{{$t('nav.nav_lang_ru')}}</div>
							<div v-if="language=='th'">{{$t('nav.nav_lang_th')}}</div>
							<div v-if="language=='fr'">{{$t('nav.nav_lang_fr')}}</div>
							<div v-if="language=='es'">{{$t('nav.nav_lang_es')}}</div>
							<div v-if="language=='de'">{{$t('nav.nav_lang_de')}}</div>
							<div v-if="language=='it'">{{$t('nav.nav_lang_it')}}</div>
							<div class="language-icon-1">
								<img src="../assets/img/nav/n-5.png" />
							</div>
						</div>
						<el-dropdown-menu slot="dropdown">
						   <el-dropdown-item style="text-align: left;"  command="0">{{$t('nav.nav_lang_zh')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="1">{{$t('nav.nav_lang_en')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="2">{{$t('nav.nav_lang_tw')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="3">{{$t('nav.nav_lang_ja')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="4">{{$t('nav.nav_lang_ko')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="5">{{$t('nav.nav_lang_ru')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="6">{{$t('nav.nav_lang_th')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="7">{{$t('nav.nav_lang_fr')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="8">{{$t('nav.nav_lang_es')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="9">{{$t('nav.nav_lang_de')}}</el-dropdown-item>
						   <el-dropdown-item style="text-align: left;"  command="10">{{$t('nav.nav_lang_it')}}</el-dropdown-item>
						 </el-dropdown-menu>
					</el-dropdown>
					<div class="cloud-space-1" v-if="loginState">
						<el-dropdown @command="changeUrl">
							<div style="cursor: pointer;display: flex;align-items: center;" :class="hasAvatar?'avatar-active':''">	
								<img v-show="!hasAvatar && avatar_update_time==0" class="dropdown-avatar-img" src="../assets/img/login/avatar.png" />
								<img v-show="hasAvatar && avatar_update_time==0" class="dropdown-avatar-img" src="../assets/img/login/avatar2.png" />
								<img v-show="avatar_update_time>0 && uid" class="dropdown-avatar-img" :src="$baseImg+`/bb/${uid}/avatar.png?x-oss-process=image/resize,m_fixed,h_100,w_100&t=${avatar_update_time}`" />
								{{$store.state.globalData.userName}}
								<i  v-show="!hasAvatar" class="bi bi-chevron-down" style="margin-left: 4px;"></i>
								<i  v-show="hasAvatar" class="bi bi-chevron-up" style="margin-left: 4px;"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
							   <el-dropdown-item style="text-align: center;border-bottom: 1px solid #E5E5E5;"  command="0">{{$t('nav.nav0')}}</el-dropdown-item>
							   <el-dropdown-item style="text-align: center;border-bottom: 1px solid #E5E5E5;"  command="1">{{$t('nav.nav1')}}</el-dropdown-item>
							   <el-dropdown-item style="text-align: center;"  command="2">{{$t('nav.nav2')}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<!-- <div class="cloud-space" v-else @click="login()">
						云空间
					</div> -->
				</div>
			</div>
		</header>
		<login ref="login"></login>
	</div>
</template>
<script>
	import {
		getSolutionCategory,
		getSolutionCategorylist,
		getUserInfo
	} from "../../common/api";
	import login from '@/components/login.vue';
	import { filters } from "../../common/filters.js";
	export default {
		components: {
			login
		},
		props: {},
		data() {
			return{
				language: 'zh',
				hasLang:false,
				isLang:false,
				loginState:false,
				uid:'',
				userName:'',
				avatar_update_time:-1,
				hasAvatar:false,
			}
		},
		watch: {
			'$route'(to, from) {
				this.loginState=localStorage.getItem('loginState')?true:false;
				this.getUserInfoData();
			},
			updtaStatus() {
				this.getUserInfoData();
			},
		},
		mounted() {
			let lang = localStorage.getItem('lang') || filters.getLocale();
			this.language=lang;
			
			this.loginState=localStorage.getItem('loginState')?true:false;
			this.getUserInfoData();
		},
		methods:{
			getUserInfoData(){
				if(this.loginState){
					const params={}
					getUserInfo(params).then((res) => {
						if(res.code==0){
							let percentage=0;
							if(res.data.capacity_info){
								percentage=(res.data.capacity_info.used/(res.data.capacity_info.total/100)).toFixed(0);
							}
							this.$store.commit('updateGlobalData',{
							    userName:res.data.email,
								avatar_update_time:res.data.avatar_update_time,
								spaceInfo:res.data.capacity_info,
								percentage:percentage
							})
							this.userName=res.data.nickname;
							this.uid=res.data.uid;
							this.avatar_update_time=res.data.avatar_update_time;
						}else{
							localStorage.setItem('loginState', '');
							this.$store.commit('updateGlobalData',{
							    userName:'',
								avatar_update_time:'',
								spaceInfo:'',
								percentage:0,
							})
							//this.$message.error(res.msg);
						}
					})
				}
			},
			login(){
				this.$nextTick(()=>{
					this.$refs.login.dialogFormVisible=true;
					this.$refs.login.activeTab=0;
					this.$refs.login.init();
				})
			},
			changeLanguage(index) {
				let that=this;
				let lang = "zh";
				let locale=['zh','en','tw','ja','ko','ru','th','fr','es','de','it'];
				locale.filter((item,index2)=>{
					if(index==index2){
						lang=item;
						that.language=item;
					}
				})
				localStorage.setItem('lang', lang);
				this.$i18n.locale = lang;
				window.location.reload();
			},
			changeUrl(index){
				if (index == 0) {
					this.$router.push({
						path: '/accountSecurity',
						query: {},
					})
				}else if(index == 1){
					this.$router.push({
						path: '/recorderCloud',
						query: {},
					})
				} else {
					localStorage.setItem('loginState', '');
					this.loginState=false;
					this.hasAvatar=false;
				}
			},
			tohome(){
				//this.$router.push('/');
				window.open('https://vormor.cn/');
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	::v-deep .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
		    background-color: rgba(230, 244, 244, 1);
		    color: rgba(16, 177, 167, 1);
	}
	.header-nav{
		height: 74px;
		display: flex;
		align-items: center;
		padding: 0 360rpx;
		box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1);
	}
	.header-top{
		width: 100%;
		display: flex;
		justify-content: space-between !important;
		padding: 0 26px;
	}
	.logo{
		width: 50px;
		height: 36px;
		cursor: pointer;
		img{
			width: 50px;
			height: 36px;
		}
	}
	.logo-not-logged{
		display: flex;
		align-items: center;
		.language-button{
			margin-top: 2px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 19px;
			text-align: left;
			font-style: normal;
			text-transform: none;
			cursor: pointer;
			
			display: flex;
			align-items: center;
			.language-icon-2{
				width: 16px;
				height: 16px;
				margin-right: 4px;
				img{
					width: 16px;
					height: 16px;
				}
			}
			.language-icon-1{
				width: 16px;
				height: 16px;
				margin-left: 8px;
				img{
					width: 16px;
					height: 16px;
				}
			}
		}
		.cloud-space-1{
			margin-left: 48px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			text-transform: none;
			cursor: pointer;
		}
		.cloud-space{
			margin-left: 48px;
			width: 102px;
			height: 32px;
			border-radius: 16px;
			border: 1px solid #999999;
			
			display: flex;
			align-items: center;
			justify-content: center;
			
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			text-transform: none;
			cursor: pointer;
		}
	}
	.dropdown-avatar-img{
		width: 24px;
		height: 24px;
		border-radius: 50%;
		margin-right: 8px;
	}
	.header-h{
		height: 74px;
	}
</style>